import { isNil } from 'lodash'

const convertBoolToString = (bool) => {
  if (isNil(bool)) return ''

  return bool ? 'Sim' : 'Não'
}

export default convertBoolToString
